import "../jsdoc/NavItem";

export default class NavigationService {

    apiPath = '/Umbraco/Api/Menu/';

    /**
     * Gets child navigation items for the page id
     * @param {number} pageId
     * @return {Promise<Array.<NavItem>>}
     */
    getChildren(pageId) {

        const currentUrl = window.location.pathname;
        const url = new URL(`${this.apiPath}GetItems`, location.origin);

        url.search = new URLSearchParams({ pageId, currentUrl }).toString();

        return fetch(url, {
                method: 'GET'
            })
            .then(response => {
                return response.json();
            });
    }
}